export const config = {
  accountId: 719324159001,
  // policy key with search enabled can be used on any domain
  policyKey:
    'BCpkADawqM2c_HC1ohkfRsLnQlVWnAjzjraQmm0Y6VURIwmWuvHdDwilZT_VHqNCzoDngwXQigJZBBvamkqzIDHghw6LZrJH_gSCT8WCfueIuwYA76SaWQ4lPrKUIiUOlntZBbUyTaDI540D',
};

interface IPlaybackParams {
  limit: string;
  sort: string;
}

export interface IBrightcovePlaybackVideo {
  poster: string;
  name: string;
  id: number;
}

export const defaultPlaybackConfig: IPlaybackParams = {
  limit: '3',
  // - means decending order
  sort: '-published_at',
};

export const getPlaybackVideos = async (
  anglerName: string,
  playbackParams: IPlaybackParams = defaultPlaybackConfig
): Promise<{ videos: IBrightcovePlaybackVideo[] }> => {
  /**
   * + is a require operator
   */
  const requireOperator = '+';
  const anglerNameTag = `tags:\"${anglerName.toLowerCase()}\"`;
  const publishDateFilter = 'published_at:NOW..2013-01-23T19:06:16.328Z';

  const params = {
    limit: encodeURIComponent(playbackParams.limit),
    sort: encodeURIComponent(defaultPlaybackConfig.sort),
    // tslint:disable-next-line: object-literal-sort-keys
    q: encodeURIComponent(
      `${publishDateFilter}${requireOperator}${anglerNameTag}`
    ),
  };

  const playbackUrl = `https://edge.api.brightcove.com/playback/v1/accounts/${config.accountId}/videos?limit=${params.limit}&sort=${params.sort}&q=${params.q}`;

  const data = await fetch(playbackUrl, {
    headers: {
      'BCOV-Policy': config.policyKey,
    },
  });

  return data.json();
};
